import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

@Injectable({ providedIn: 'root' })
export class DeletePaymentMethodService {
    public constructor(private _http: HttpClient, @Inject(SETTINGS) private _settings: ISettings) {}

    public execute(paymentMethodKey: string): Promise<void> {
        const url = `${this._settings.httpApiServiceNameUrlMap['paymentsApi']}/v1/payment-method/${paymentMethodKey}`;
        return this._http.delete<void>(url).toPromise();
    }
}
